var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2D2D2D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12609_42483)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12609_42483",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 14,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4.84375H5V19.1588H19V4.84375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12609_42483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3319 10.9021L18.5437 4.84375H17.3087L12.7833 10.1041L9.16883 4.84375H5L10.4657 12.7983L5 19.1514H6.2351L11.0141 13.5963L14.8312 19.1514H19L13.3316 10.9021H13.3319ZM11.6403 12.8684L11.0865 12.0763L6.68013 5.77352H8.57717L12.1331 10.8601L12.6869 11.6522L17.3093 18.2639H15.4122L11.6403 12.8687V12.8684Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12609_42483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14.315,
    fill: "white",
    transform: "translate(5 4.84375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.6f26740f4550e592ef6e30339cde5a3f.svg";
export { ForwardRef as ReactComponent };